import { Typography } from '@mui/joy';
import React, { createContext, FC, PropsWithChildren, useContext } from 'react';

export const HeadingLevelContext = createContext<HeadingLevel | null>(null);

export const useHeadingLevel = () => useContext(HeadingLevelContext);

export type HeadingLevel = 'h1' | 'h2' | 'h3' | 'h4';

export const makeHeading = (level: HeadingLevel) => {
  const Component: FC<PropsWithChildren> = ({ children, ...props }) => (
    <Typography level={level} component={level}>
      <HeadingLevelContext.Provider value={level}>{children}</HeadingLevelContext.Provider>
    </Typography>
  );

  return Component;
};
